import jsPDF from "jspdf";
import template from "../assets/images/receiptTemplate.png";

export const generateReceipt = (savedPayment) => {
  const doc = new jsPDF();

  const img = new Image();
  img.src = template;

  img.onload = () => {
    doc.addImage(img, "PNG", 0, 0, 210, 297);
    doc.setFontSize(12);

    // Invoice
    doc.text(savedPayment.invoice || "", 45, 122);

    // Date
    const formattedDate = new Date(savedPayment.date).toLocaleDateString(
      "en-IN",
      {
        day: "2-digit",
        month: "short",
        year: "numeric",
      }
    );
    doc.text(formattedDate, 155, 121);

    // Student
    doc.text(savedPayment.studentName || "", 40, 142);

    // Batch
    doc.text(savedPayment.batch || "", 145, 141);

    // Coach
    doc.text(savedPayment.coach || "", 55, 150);

    // Slot
    doc.text(savedPayment.slot || "", 145, 150);

    const amount = parseInt(savedPayment.amount);

    doc.setFont("helvetica", "bold");

    doc.text("" + amount, 163, 177);
    doc.text("0", 163, 187);
    doc.text("0", 163, 197);
    doc.text("" + amount, 163, 207);

    // Payment Mode
    doc.text(savedPayment.paymentMode || "", 120, 223);

    // Payment Status
    doc.text(savedPayment.status || "", 120, 230);

    // ✅ FINAL MOBILE + LAPTOP FIX
    const pdfBlob = doc.output("blob");

    const file = new File([pdfBlob], "receipt.pdf", {
      type: "application/pdf",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(file);
    link.download = "receipt.pdf";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
};